/**
 * Site search trong thân trang campaign migrate (`/pages/presentcp`, ...) — port
 * `searchSiteForKiji()` (script nhúng trong body Joomla) + template kết quả
 * `browse/includes/site_search_for_kiji.tpl.php` + `shop.site_search_for_kiji_ajax.php`.
 *
 * Markup mỗi ô search nằm trong `Page.body` migrate từ Joomla, theo bộ id/name có
 * hậu tố per-instance (`keySiteSearch_v2`, `siteSearchMaker_v2`, `resultBox_v2`...,
 * một trang có thể có nhiều ô — presentcp có v2 + v3). Script gốc nhúng cùng body đã
 * bị Shopify strip khi import (Shopify xoá sạch `<script>`/`<style>` khỏi body page),
 * nên toàn bộ handler phải sống ở theme — file này. Bind theo `name^=keySiteSearch_`
 * nên chỉ cần nhúng file là mọi ô trên trang chạy.
 *
 * API: GET /apps/ink/api/v1/search/suggestions?q=&maker=&checked=
 *   `shop.site_search_for_kiji_ajax.php` chỉ khác `shop.site_search_ajax.php` ở
 *   param `prefix` (đổi id/name trong markup trả về) — engine search là MỘT, nên
 *   dùng chung endpoint với search overlay (`assets/search-overlay.js`).
 *
 * Helper `esc`/`handleize`/`collectionUrl`/`whenApiReady` + bảng remap maker/kind là
 * bản copy có chủ ý từ `search-overlay.js`/`toner-page-search.js`: theme để mỗi
 * asset là 1 IIFE tự chứa.
 *
 * Link kết quả: site cũ trỏ `/index.php/{category_link}.html`; ở đây là
 * `/collections/{handle}` — collection chưa tồn tại thì ra 404 native (giống search
 * overlay + chip 適合プリンター).
 *
 * Class panel sinh bằng string ở đây khai trong
 * `assets/shopify-fixed-page-content.modules.css` (scope `data-page-handle`).
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 300;
  var MAX_REQUESTS_PER_MINUTE = 40;
  var RATE_WINDOW_MS = 60000;

  // Category「レンタルPLUS株式会社様専用販売ページ」bị loại khỏi kết quả + không
  // tính vào 件数 (port shop.site_search_ajax.php:54-58 — nhánh kiji giữ nguyên).
  var RENTAL_PLUS_NAME = 'レンタルPLUS株式会社様専用販売ページ';

  // makerListJPSearch (ps_product_category.cfg.php) — maker_id (đã remap) → tên nhóm.
  var MAKER_LABELS = {
    1: 'EPSON',
    2: 'Canon',
    5: 'brother',
    6: 'hp',
    7: 'RICOH',
    8: 'DELL',
    9: 'LEXMARK',
    10: 'EMシステムズ',
    11: 'その他',
  };

  // kind_search (ps_product_category.cfg.php) — category_kind → hậu tố tiêu đề nhóm.
  var KIND_TITLES = {
    0: '',
    1: ' / インク型番名',
    2: ' / トナー型番名',
    3: ' / プリンター型番名',
    4: ' / プリンター型番名',
    5: ' / その他',
    6: ' / その他',
    99: ' / その他',
  };

  // 種類 checkbox — site_search_for_kiji.tpl.php:19-37.
  var KIND_OPTIONS = [
    { id: 'ink', value: '1', label: 'インク型番' },
    { id: 'tonner', value: '2', label: 'トナー型番' },
    { id: 'printer', value: '3', label: 'プリンター型番' },
    { id: 'other', value: '99', label: 'その他' },
  ];

  // メーカー radio — $makerListJP của site_search_for_kiji.tpl.php:2-8 (ngắn hơn
  // select trong body; 999 = その他).
  var MAKER_OPTIONS = [
    { value: '0', label: 'すべて' },
    { value: '1', label: 'EPSON' },
    { value: '2', label: 'Canon' },
    { value: '5', label: 'brother' },
    { value: '999', label: 'その他' },
  ];

  // Trần request dùng chung mọi ô trên trang (requestCountKiji của script gốc là
  // biến module-scope, cũng đếm chung).
  var requestCount = 0;
  var rateWindowStart = Date.now();

  function withinRateLimit() {
    var now = Date.now();
    if (now - rateWindowStart > RATE_WINDOW_MS) {
      rateWindowStart = now;
      requestCount = 0;
    }
    if (requestCount >= MAX_REQUESTS_PER_MINUTE) {
      console.warn('1分間に40回のリクエストの上限に達しました。しばらくお待ちください。');
      return false;
    }
    requestCount += 1;
    return true;
  }

  // `api-client.js` load cuối body và set `window.inkApi` trong DOMContentLoaded của
  // chính nó; script này được nhúng từ page content nên chạy TRƯỚC → phải chờ
  // event `ink:api:ready`.
  function whenApiReady(timeoutMs) {
    if (window.inkApi) return Promise.resolve(window.inkApi);
    return new Promise(function (resolve) {
      var done = function () {
        resolve(window.inkApi || null);
      };
      document.addEventListener('ink:api:ready', done, { once: true });
      setTimeout(done, timeoutMs);
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Handleize giống Liquid filter: lowercase, ký tự không phải chữ/số → '-', trim '-'.
  function handleize(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-+|-+$/g, '');
  }

  function collectionUrl(item) {
    var handle = item.shopify_collection_handle || handleize(item.category_name);
    // Handle rỗng (tên toàn ký tự đặc biệt) → giữ tên raw để chắc chắn 404, tránh
    // `/collections/` trần (Shopify render danh sách toàn bộ collection).
    return '/collections/' + (handle || encodeURIComponent(item.category_name || 'not-found'));
  }

  // Remap category_maker → key makerListJPSearch (port shop.site_search_ajax.php:64-83,
  // giữ nguyên chuỗi if tuần tự — DELL(9)/LEXMARK(8) đều gộp về 9=LEXMARK như site cũ).
  function remapMaker(rawId) {
    var id = parseInt(rawId, 10) || 0;
    if ((id < 1 || id > 9) && id !== 15) id = 11;
    if (id === 9) id = 8;
    if (id === 8) id = 9;
    if (id === 15) id = 11;
    return id;
  }

  // Tên hiển thị — port shop.site_search_ajax.php:59-63:
  // category_name_text ưu tiên; else symbol_mark → "name（symbol）"; else name.
  function displayName(item) {
    if (item.category_name_text) return item.category_name_text;
    if (item.symbol_mark) return item.category_name + '（' + item.symbol_mark + '）';
    return item.category_name;
  }

  /**
   * Gom item theo maker × kind — port `$jsonArr` của shop.site_search_for_kiji_ajax:
   * outer sort maker asc, inner theo thứ tự API (đã ORDER BY kind,maker,name).
   */
  function groupsHtml(items) {
    var groups = {};
    items.forEach(function (item) {
      var maker = remapMaker(item.category_maker);
      var kindTitle = KIND_TITLES[item.category_kind] || '';
      if (!groups[maker]) groups[maker] = {};
      if (!groups[maker][kindTitle]) groups[maker][kindTitle] = [];
      groups[maker][kindTitle].push(item);
    });

    var makerKeys = Object.keys(groups)
      .map(function (k) {
        return parseInt(k, 10);
      })
      .sort(function (a, b) {
        return a - b;
      });

    var html = '';
    makerKeys.forEach(function (maker) {
      var makerLabel = MAKER_LABELS[maker] || '';
      Object.keys(groups[maker]).forEach(function (kindTitle) {
        var cells = groups[maker][kindTitle]
          .map(function (item) {
            return '<li><a href="' + esc(collectionUrl(item)) + '">' + esc(displayName(item)) + '</a></li>';
          })
          .join('');
        html += '<div class="resultTit">' + esc(makerLabel + kindTitle) + '</div><ul>' + cells + '</ul>';
      });
    });
    return html;
  }

  /**
   * Khối 絞り込み検索 — port site_search_for_kiji.tpl.php:17-48.
   * `name`/`id` gắn hậu tố `ver`: nhiều ô cùng trang, để nguyên tên gốc thì radio
   * các ô chung một group và `<label for>` của ô dưới toggle checkbox của ô trên.
   */
  function refineHtml(ver, checkedKinds, radioMaker) {
    var kindBoxes = KIND_OPTIONS.map(function (kind) {
      var id = kind.id + '-' + ver;
      return (
        '<span class="Refine__Check"><input id="' + esc(id) +
        '" name="typeSiteSearch_' + esc(ver) +
        '" value="' + kind.value + '" type="checkbox"' +
        (checkedKinds.indexOf(kind.value) !== -1 ? ' checked' : '') +
        '><label for="' + esc(id) + '">' + esc(kind.label) + '</label></span>'
      );
    }).join('');

    var makerRadios = MAKER_OPTIONS.map(function (maker) {
      var id = 'site_search_maker_' + maker.value + '-' + ver;
      return (
        '<span class="Refine__Check"><input type="radio" id="' + esc(id) +
        '" name="siteSearchMaker2_' + esc(ver) +
        '" value="' + esc(maker.value) + '"' +
        (maker.value === radioMaker ? ' checked' : '') +
        '><label for="' + esc(id) + '">' + esc(maker.label) + '</label></span>'
      );
    }).join('');

    return (
      '<div class="ModelNumberResultBox__Refine">' +
      '<div class="Refine__MainTitle">絞り込み検索</div>' +
      '<div class="Refine__Box Refine__Box--Type"><div class="Refine__SubTitle">種類：</div>' + kindBoxes + '</div>' +
      '<div class="Refine__Box"><div class="Refine__SubTitle">メーカー：</div>' + makerRadios + '</div>' +
      '</div>'
    );
  }

  function panelHtml(ver, count, checkedKinds, radioMaker, items) {
    return (
      '<div class="searchBox__printerResultBox">' +
      '<div class="searchBox__printerResultBoxInner">' +
      '<div class="ModelNumberResultBox__HitNum">検索結果：' + esc(String(count)) + '件</div>' +
      refineHtml(ver, checkedKinds, radioMaker) +
      groupsHtml(items) +
      '<a class="searchBox__closeBtn" role="button" tabindex="0">検索結果を閉じる</a>' +
      '<a class="searchBox__closeIconBtn" role="button" tabindex="0" aria-label="検索結果を閉じる"></a>' +
      '</div></div>'
    );
  }

  function bind(input) {
    if (input.dataset.inkSiteSearchBound === '1') return;
    input.dataset.inkSiteSearchBound = '1';

    var ver = input.name.slice('keySiteSearch_'.length);
    var makerSelect = document.getElementById('siteSearchMaker_' + ver);
    var result = document.getElementById('resultBox_' + ver);
    if (!ver || !result) return;

    var timer = null;
    var seq = 0;
    var cache = Object.create(null);
    // Radio メーカー trong khối kết quả (categoryCheckOption): null = chưa chọn →
    // dùng select; đã chọn (kể cả '0') → override select, giống search overlay.
    var radioMaker = null;

    function checkedKinds() {
      return Array.prototype.map.call(
        result.querySelectorAll('input[name="typeSiteSearch_' + ver + '"]:checked'),
        function (el) {
          return el.value;
        },
      );
    }

    function effectiveMaker() {
      if (radioMaker !== null) return radioMaker;
      return (makerSelect && makerSelect.value) || '0';
    }

    function clearPanel() {
      result.innerHTML = '';
    }

    function render(count, kinds, items) {
      result.innerHTML = panelHtml(ver, count, kinds, radioMaker, items);
    }

    // API lỗi → thông báo lỗi thay panel (onFailure của searchSiteForKiji gốc).
    function renderError() {
      result.innerHTML =
        '<div class="error-message">検索中にエラーが発生しました。もう一度お試しください。</div>';
    }

    function search() {
      // Ô rỗng → clear kết quả, không gọi API (searchSiteForKiji: `if (!word)`).
      var word = input.value.trim();
      if (!word) {
        clearPanel();
        return;
      }

      var kinds = checkedKinds();
      var maker = effectiveMaker();
      var cacheKey = maker + '|' + kinds.join(',') + '|' + word;
      var ticket = (seq += 1);

      if (cache[cacheKey]) {
        var hit = cache[cacheKey];
        render(hit.count, kinds, hit.items);
        return;
      }

      if (!withinRateLimit()) return;

      var params = { q: word };
      if (maker !== '0') params.maker = maker;
      if (kinds.length) params.checked = kinds.join(',');

      whenApiReady(3000)
        .then(function (api) {
          if (!api) return null;
          return api.get('/search/suggestions', params);
        })
        .then(function (res) {
          // Response về sau khi user đã gõ tiếp → bỏ, tránh đè kết quả mới hơn.
          if (ticket !== seq) return;
          if (res === null || res.error) {
            renderError();
            return;
          }
          var results = (res && res.data && res.data.results) || [];
          var items = results.filter(function (r) {
            return r.category_name !== RENTAL_PLUS_NAME && r.category_name_text !== RENTAL_PLUS_NAME;
          });
          cache[cacheKey] = { count: items.length, items: items };
          render(items.length, kinds, items);
        })
        .catch(function (e) {
          console.warn('site search suggestions load fail', e);
          if (ticket === seq) renderError();
        });
    }

    function debouncedSearch() {
      clearTimeout(timer);
      timer = setTimeout(search, DEBOUNCE_MS);
    }

    // Site cũ: input debounce 300ms (initSearch) + onclick trên ô → search ngay.
    input.addEventListener('input', debouncedSearch);
    input.addEventListener('click', search);

    // Select maker trong form → re-search ngay (mirror onchange gốc). Radio kết quả
    // đã chọn thì VẪN override select (site_search_for_kiji_ajax.php:41-43:
    // `categoryCheckOption != 'null'` luôn đè `categorycheck`; radio giữ checked
    // qua các lần re-render nên đổi select không gỡ được nó).
    if (makerSelect) {
      makerSelect.addEventListener('change', search);
    }

    // Delegation: khối 絞り込み render lại sau mỗi lần search nên không bind trực
    // tiếp vào radio/checkbox (site cũ dùng inline onclick trong markup trả về).
    result.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.name) return;
      if (target.name === 'siteSearchMaker2_' + ver) {
        if (target.checked) radioMaker = target.value;
        search();
        return;
      }
      if (target.name === 'typeSiteSearch_' + ver) {
        search();
      }
    });

    result.addEventListener('click', function (e) {
      if (e.target.closest('.searchBox__closeBtn, .searchBox__closeIconBtn')) {
        clearPanel();
      }
    });
  }

  function bindAll() {
    document.querySelectorAll('input[name^="keySiteSearch_"]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
